exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmationConatiner{width:80%;margin-left:10%;white-space:normal}.confirmationConatiner .flexRow{display:flex;flex-direction:row;align-items:center;justify-content:space-between;margin-bottom:.5em}.confirmationConatiner .itemLabel{font-weight:700;min-width:40%}.confirmationConatiner .selectedItems{text-align:right}.confirmationConatiner .emailInput{border:2px solid #ddd;border-radius:5px;width:50%;box-sizing:border-box;padding:.2em}.confirmationConatiner .emailInput:focus{border-color:#00a0f4;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/exports/data_export_confirmation.scss
// module id = 1297
// module chunks = 0